import { render } from "./Projects.vue?vue&type=template&id=62d5907f&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=62d5907f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62d5907f"

export default script